import ValidationType from '../ValidationType';
import { numberIsGreaterThan, numbersAreEqual } from "../../util";

class EqualsField extends ValidationType {

  get comparesField() {
    return true
  }

  validateResponseWithValidation(fieldResponse, validation, formResponse = null) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      if (validation.target) {
        const targetFieldResponse = formResponse
          ? fieldResponse.recapResponse.getFieldResponseForFieldInstanceIdAndFormResponseId(validation.target.id, formResponse.id)
          : fieldResponse.recapResponse.getFieldResponseForFieldInstanceId(validation.target.id);
        const current = fieldResponse.currentValue;
        const compare = targetFieldResponse.currentValue;
        if (!numbersAreEqual(current, compare)) {
          const error = this.createValidationError({
            fieldResponse,
            key: 'ERROR_EQUAL_TO_SPECIFIED_FIELD',
            values: { value: targetFieldResponse.currentValue },
            message: `Value should be or equal to '${targetFieldResponse.currentValue}'`,
          });
          errors.push(error);
        }
      } else {
        console.warn("No target present for validation", validation);
      }
    }
    return errors;
  }
}

export default EqualsField;
